/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const dispatchAllPlans = (data) => {
  return {
    type: actionTypes.GET_ALL_PLANS,
    allPlans: data,
  };
};

export const setPlanSearchValues = (data) => {
  return {
    type: actionTypes.SET_PLAN_SEARCH_VALUES,
    payload: data,
  };
};

export const dispatchRebateProgramCode = (data) => {
  return {
    type: actionTypes.GET_ALL_PLAN_BY_REBATE_PROGRAM_CODE,
    rebateProgramCode: data,
  };
};

export const dispatchOpenOrClossComent = (value) => {
  return {
    type: actionTypes.OPEN_COMMENTS,
    openComments: value,
  };
};
export const dispatchgetPlansByCgp = (values) => {
  return {
    plansByCgp: values,
    type: actionTypes.GET_PLANS_BY_CGP,
  };
};
export const dispatchGetAllClientsDropDown = (values) => {
  return {
    allClientDropDown: values,
    type: actionTypes.GET_ALL_CLIENTS_FOR_PLAN,
  };
};

export const dispatchGetAllGroupsDropDown = (values) => {
  return {
    allGropsForClientDropDown: values,
    type: actionTypes.GET_ALL_GROUPS_FOR_CLIENT_DROPDOWN,
  };
};

export const dispatchGetRebateProgramCodeFromCGP = (values) => {
  return {
    allRebateProgramCode: values,
    type: actionTypes.GET_REBATE_PROGRAM_CODE_FROM_CGP,
  };
};
export const dispatchSaveOrUpdate = (values) => {
  return {
    saveOrUpdateMessage: values,
    type: actionTypes.SAVE_OR_UPDATE,
  };
};

export const saveContactData = (values) => {
  return {
    contactData: values,
    type: actionTypes.SAVE_CONTACT_DATA,
  };
};
export const resetContactData = () => {
  return {
    type: actionTypes.RESET_CONTACT_DATA,
  };
};
export const setReduxDataSearchScreen = (payload) => {
  return {
    type: actionTypes.REDUX_STORE_DATA_SEARCH_SER,
    payload,
  };
};
export const dispatchContactTypeClient = (values) => {
  return {
    allContactTypeDropDownClient: values,
    type: actionTypes.GET_CONTACT_TYPE_CLIENT,
  };
};
export const dispatchContactTypeGroup = (values) => {
  return {
    allContactTypeDropDownGroup: values,
    type: actionTypes.GET_CONTACT_TYPE_GROUP,
  };
};
export const dispatchContactTypePlan = (values) => {
  return {
    allContactTypeDropDownPlan: values,
    type: actionTypes.GET_CONTACT_TYPE_PLAN,
  };
};
export const dispatchContactTypeProvider = (values) => {
  return {
    allContactTypeDropDownProvider: values,
    type: actionTypes.GET_CONTACT_TYPE_PROVIDER,
  };
};
export const dispatchExistingContactDetailsClient = (data) => ({
  type: actionTypes.GET_EXISTING_CONTACT_DETAILS_CLIENT,
  existingContactDetailsClient: data,
});
export const dispatchExistingContactDetailsGroup = (data) => ({
  type: actionTypes.GET_EXISTING_CONTACT_DETAILS_GROUP,
  existingContactDetailsGroup: data,
});
export const dispatchExistingContactDetailsPlan = (data) => ({
  type: actionTypes.GET_EXISTING_CONTACT_DETAILS_PLAN,
  existingContactDetailsPlan: data,
});
export const dispatchExistingContactDetailsProvider = (data) => ({
  type: actionTypes.GET_EXISTING_CONTACT_DETAILS_PROVIDER,
  existingContactDetailsProvider: data,
});
export const dispatchContactDetailsClient = (data) => ({
  type: actionTypes.GET_CONTACT_DETAILS_CLIENT,
  contactDetailsClient: data,
});
export const dispatchContactDetailsGroup = (data) => ({
  type: actionTypes.GET_CONTACT_DETAILS_GROUP,
  contactDetailsGroup: data,
});
export const dispatchContactDetailsPlan = (data) => ({
  type: actionTypes.GET_CONTACT_DETAILS_PLAN,
  contactDetailsPlan: data,
});
export const dispatchContactDetailsProvider = (data) => ({
  type: actionTypes.GET_CONTACT_DETAILS_PROVIDER,
  contactDetailsProvider: data,
});
export const dispatchUpdateContactDetail = (message) => {
  return {
    type: actionTypes.UPDATE_CONTACT_DETAILS,
    updateOrSaveContactDetailsMessage: message,
  };
};
export const softDeleteRowData = (data) => {
  return {
    type: actionTypes.SOFT_DELETE_DATA,
    softDeleteRowData: data,
  };
};

export const dispatchDeletePlanDetails = (message) => {
  return {
    type: actionTypes.DELETE_PLAN_DETAILS,
    deleteMessageResponse: message,
  };
};
export const deletePlanHandleFromGridComponent = (value) => {
  return {
    type: actionTypes.DELETE_PLAN_HANDLE_FROM_GRID_COMPONENT,
    deletePlan: value,
  };
};
export const dispatchPlanWhenUserUpdateFromCustomGridComponet = (data) => {
  return {
    plansByCgp: data,
    type: actionTypes.UPDATE_PLAN_WHEN_USER_UPDATE,
  };
};
export const dispatchNewDate = (data) => {
  return {
    newDate: data,
    type: actionTypes.ADD_NEW_DATE,
  };
};
export const dispatchCreateNewPlan = (data) => {
  return {
    plansByCgp: data,
    type: actionTypes.CREATE_NEW_PLAN,
  };
};
export const dispatchUpdateDatesRows = (data) => {
  return {
    datesRows: data,
    type: actionTypes.UPDATE_DATES_ROWS,
  };
};
export const setIsValidContactForm = (data) => {
  return {
    isValidContactForm: data,
    type: actionTypes.CONTACT_FORM_VALIDITY,
  };
};

export const setPlanDataAction = (payload) => {
  return {
    type: actionTypes.PLAN_DATA_ACTION_TYPES,
    payload,
  };
};

export const setPlanTabData = (data) => {
  return {
    planTabData: data,
    type: actionTypes.PLAN_TAB_DATA,
  };
};

export const createNewPlanToStore = (data) => (dispatch) => {
  return dispatch(dispatchCreateNewPlan(data));
};

export const updateDatesRows = (data) => (dispatch) => {
  return dispatch(dispatchUpdateDatesRows(data));
};
export const addNewDateToStore = (data) => (dispatch) => {
  return dispatch(dispatchNewDate(data));
};
export const resetUpdateContactDetail = (message) => (dispatch) => {
  return dispatch(dispatchUpdateContactDetail(message));
};
export const resetUpdateOrSaveMessage = (message) => (dispatch) => {
  return dispatch(dispatchSaveOrUpdate(message));
};
export const updatePlanWhenUserUpdateFromCustomComponent =
  (data) => (dispatch) => {
    return dispatch(dispatchPlanWhenUserUpdateFromCustomGridComponet(data));
  };
export const deletePlanDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.DELETE_PLAN_DETAILS, values)
    .then((response) => {
      dispatch(dispatchDeletePlanDetails(response.data));
    })
    .catch(() => {
      dispatch(dispatchDeletePlanDetails({ error: 'API failed' }));
    });
};
export const updateContactDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_CONTACT_DETAILS, values)
    .then((response) => {
      dispatch(dispatchUpdateContactDetail(response.data));
    })
    .catch(() => {
      dispatch(dispatchUpdateContactDetail({ error: 'API failed' }));
    });
};
export const getContactDetails = (values, type) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CONTACT_DETAILS, values)
    .then((response) => {
      if (type === 'client') {
        dispatch(dispatchContactDetailsClient(response.data));
      }
      if (type === 'group') {
        return dispatch(dispatchContactDetailsGroup(response.data));
      }
      if (type === 'plan') {
        return dispatch(dispatchContactDetailsPlan(response.data));
      }
      if (type === 'provider') {
        return dispatch(dispatchContactDetailsProvider(response.data));
      }
    })
    .catch(() => {
      if (type === 'client') {
        dispatch(dispatchContactDetailsClient({ error: 'API failed' }));
      }
      if (type === 'group') {
        return dispatch(dispatchContactDetailsGroup({ error: 'API failed' }));
      }
      if (type === 'plan') {
        return dispatch(dispatchContactDetailsPlan({ error: 'API failed' }));
      }
      if (type === 'provider') {
        return dispatch(
          dispatchContactDetailsProvider({ error: 'API failed' })
        );
      }
    });
};

export const getExistingContactDetails = (values, type) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_CONTACT_DETAILS, values)
    .then((response) => {
      if (type === 'client') {
        dispatch(dispatchExistingContactDetailsClient(response.data));
      } else if (type === 'group') {
        dispatch(dispatchExistingContactDetailsGroup(response.data));
      } else if (type === 'plan') {
        dispatch(dispatchExistingContactDetailsPlan(response.data));
      } else if (type === 'provider') {
        dispatch(dispatchExistingContactDetailsProvider(response.data));
      }
    })
    .catch(() => {
      if (type === 'client') {
        dispatch(dispatchExistingContactDetailsClient({ error: 'API failed' }));
      } else if (type === 'group') {
        dispatch(dispatchExistingContactDetailsGroup({ error: 'API failed' }));
      } else if (type === 'plan') {
        dispatch(dispatchExistingContactDetailsPlan({ error: 'API failed' }));
      } else if (type === 'provider') {
        dispatch(
          dispatchExistingContactDetailsProvider({ error: 'API failed' })
        );
      }
    });
};
export const getAllContactType = (value, type) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CONTACT_DESCRIPTION_DETAILS, value)
    .then((response) => {
      if (type === 'client') {
        return dispatch(dispatchContactTypeClient(response.data));
      }
      if (type === 'group') {
        return dispatch(dispatchContactTypeGroup(response.data));
      }
      if (type === 'plan') {
        return dispatch(dispatchContactTypePlan(response.data));
      }
      if (type === 'provider') {
        return dispatch(dispatchContactTypeProvider(response.data));
      }
    })
    .catch(() => {
      if (type === 'client') {
        return dispatch(dispatchContactTypeClient([]));
      }
      if (type === 'group') {
        return dispatch(dispatchContactTypeGroup([]));
      }
      if (type === 'plan') {
        return dispatch(dispatchContactTypePlan([]));
      }
      if (type === 'provider') {
        return dispatch(dispatchContactTypeProvider([]));
      }
    });
};
export const postSaveOrUpdate = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.SAVE_OR_UPDATE, value)
    .then((response) => {
      return dispatch(dispatchSaveOrUpdate(response.data));
    })
    .catch(() => {
      dispatch(dispatchSaveOrUpdate('failed'));
    });
};
export const getRebateProgramCodeFromCGP = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_REBATE_PROGRAM_CODE_FROM_CGP)
    .then((response) => {
      return dispatch(dispatchGetRebateProgramCodeFromCGP(response.data.data));
    })
    .catch(() => {
      dispatch(dispatchGetRebateProgramCodeFromCGP([]));
    });
};
export const getAllGroupsDropDown = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_GROUPS_FOR_CLIENT_DROPDOWN, value)
    .then((response) => {
      return dispatch(dispatchGetAllGroupsDropDown(response.data.data));
    })
    .catch(() => {
      dispatch(dispatchGetAllGroupsDropDown([]));
    });
};
export const getAllClientsDropDown = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_ALL_CLIENTS_FOR_PLAN)
    .then((response) => {
      return dispatch(dispatchGetAllClientsDropDown(response.data.data));
    })
    .catch((response) => {
      dispatch(dispatchGetAllClientsDropDown(response));
    });
};
export const getPlansByCgp = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PLANS_BY_CGP, value)
    .then(async (response) => {
      dispatch(getAllContactType({ keyTypeCd: 'CGP' }, 'plan'));
      dispatch(
        getExistingContactDetails(
          {
            key: [
              `${value?.clientId?.trim()}${value?.groupId?.trim()}${value?.planId?.trim()}`,
            ],
            keyTypeCd: 'CGP',
          },
          'plan'
        )
      );
      const existingCommentIdList = await getExistingCommentLinkIds(
        response.data?.data?.map((item) => item.corrLinkId)
      );
      const updatedData = response.data?.data?.map((item) => ({
        ...item,
        ccCommentsExist: existingCommentIdList.includes(item.corrLinkId)
          ? 1
          : 0,
      }));
      return dispatch(dispatchgetPlansByCgp(updatedData));
    })
    .catch((response) => {
      dispatch(dispatchAllPlans(response));
    });
};

export const getExistingCommentLinkIds = async (idList) => {
  try {
    const response = await axios.post(
      serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS,
      {
        corrLinkId: idList,
      }
    );
    return response.data?.data ?? [];
  } catch (e) {
    return [];
  }
};

export const handleOpenComments = (values) => (dispatch) => {
  return dispatch(dispatchOpenOrClossComent(values));
};
export const getAllPlans = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_PLANS}`, values)
    .then((response) => {
      return dispatch(dispatchAllPlans(response.data));
    })
    .catch((response) => {
      dispatch(dispatchAllPlans(response));
    });
};

export const getAllRebateProgramCode = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_PLAN_BY_REBATE_PROGRAM_CODE}`, values)
    .then((response) => {
      return dispatch(
        dispatchRebateProgramCode(response.data.data ? response.data.data : [])
      );
    })
    .catch((response) => {
      dispatch(dispatchRebateProgramCode(response));
    });
};
export const clearReduxForMaintainPlanScreen = (payload) => {
  // const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  // if (
  //   (payload === '/plan' &&
  //     !updateTabs.filter((x) => {
  //       return x.navTo === '/createNewPlan';
  //     }).length > 0) ||
  //   (payload === '/createNewPlan' &&
  //     !updateTabs.filter((x) => {
  //       return x.navTo === '/plan';
  //     }).length > 0)
  // ) {
  //   return {
  //     type: actionTypes.CLEAR_REDUX_DATA,
  //     payload,
  //   };
  // }
  // return null;
};
